/**
 * Created with IntelliJ IDEA.
 * User: tomers
 * Date: 12/29/16
 * Time: 3:11 PM
 * To change this template use File | Settings | File Templates.
 */

define(function (require) {
    "use strict";

    var LE = require("app");
    var BaseModel = require("models/BaseModel");
    var DateUtility = require("utils/DateUtility");
    var NameUtility = require("utils/NameUtility");

    var KEYS = {
        "ID": "id",
        "OBJECT_TYPE": "objectType",
        "OBJECT_ID": "objectId",
        "OBJECT_NAME": "objectName",
        "ACTION_TYPE": "actionType",
        "ELEMENT": "element ",
        "OLD_VALUE": "oldValue",
        "NEW_VALUE": "newValue",
        "CHANGE_DATE": "changeDate",
        "ORIGINATOR": "originator",
        "ORIGINATOR_LOGIN_NAME": "originatorLoginName",
        "DISPLAY_TYPE": "displayType"
    };

    var DISPLAY_TYPES = {
        BIG_JSON: "BIG_JSON"
    };

    // Note: these values also in use in languino
    var OBJECT_TYPES = {
        USER: "ACUserObject",
        SKILL: "ACSkillObject",
        AGENT_GROUP: "ACAgentGroupObject",
        PROFILE: "ACProfileObject",
        LOB: "ACLobObject",
        POST_CONVERSATION_SURVEY: "ACPostSurvey",
        CATEGORIES: "ACCategoryObject",
        PREDEFINED_CONTENT: "ACCannedResponse",
        SHIFT_SCHEDULER: "ShiftSchedulerDummyType",
        SCHEDULE: "ACWorkingHours",
        SPECIAL_OCCASION: "ACSpecialOccasion",
        CAMPAIGNS: "LECampaignObject"
    };

    var MAX_DISPLAY_LENGTH = 300;

    var AuditTrailModel = {};
    function moduleDefinition(LEManager, LE, Backbone, Marionette, $, _) {

        AuditTrailModel = BaseModel.extend({
            KEYS: KEYS,
            name: "AuditTrailModel",
            defaults : {
                id : null
            },

            //--------------------------------------------------------
            // getters & setters
            //--------------------------------------------------------

            getId: function () {
                return this.get(KEYS.ID);
            },
            getObjectType: function() {
                return this.get(KEYS.OBJECT_TYPE);
            },
            getObjectId: function() {
                return this.get(KEYS.OBJECT_ID);
            },
            getObjectName: function() {
                return this.get(KEYS.OBJECT_NAME);
            },
            getActionType: function() {
                return this.get(KEYS.ACTION_TYPE);
            },
            getElement: function() {
                return this.get(KEYS.ELEMENT);
            },
            getOldValue: function() {
                return this.get(KEYS.OLD_VALUE);
            },
            getNewValue: function() {
                return this.get(KEYS.NEW_VALUE);
            },
            getChangeDate: function() {
                return this.get(KEYS.CHANGE_DATE);
            },
            getOriginator: function() {
                return this.get(KEYS.ORIGINATOR);
            },
            getOriginatorLoginName: function() {
                return this.get(KEYS.ORIGINATOR_LOGIN_NAME);
            },
            getOriginatorUserId: function() {
                return this.get(KEYS.ORIGINATOR_USER_ID);
            },
            getOriginatorIsLpa: function() {
                return this.get(KEYS.ORIGINATOR_IS_LPA);
            },

            getDisplayType: function() {
                return this.get(KEYS.DISPLAY_TYPE);
            },

            shouldDisplayReviewChanges: function () {
                return this.getDisplayType() === DISPLAY_TYPES.BIG_JSON ||
                        (typeof this.getOldValue() !== 'undefined' && this.getOldValue().length > MAX_DISPLAY_LENGTH) ||
                        (typeof this.getNewValue() !== 'undefined' && this.getNewValue().length > MAX_DISPLAY_LENGTH);
            }
        });
    }

    LE.module("LEManager", moduleDefinition);
    AuditTrailModel.KEYS = KEYS;
    AuditTrailModel.OBJECT_TYPES = OBJECT_TYPES;

    return AuditTrailModel;
});
